import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Toast, ToasterService } from 'angular2-toaster';
import { ConfigService } from 'src/app/services/config.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  countryCode: any = [];
  selectedCountryCode: any;
  url: string;
  phoneNum: any = null;
  configJsonObj: any = [];
  cdnURL: string;
  searchCountryOrCode: any;
  filteredCountry: any;
  popupVisible = false;
  constructor(
    private router: Router,
    public http: HttpClient,
    private route: ActivatedRoute,
    public config: ConfigService,
    private loginService: LoginService,
    public toasterService: ToasterService
  ) {
    this.http.get('assets/config.json').subscribe(async (res: any) => {
      try {

        localStorage.setItem("url", res.baseURL);
        localStorage.setItem("appCode", res.appCode);
        localStorage.setItem("projectURL", res.projectURL);
        localStorage.setItem("privacy", res.privacy);
        localStorage.setItem("terms", res.terms);
        try {

          const DOMAINS: string[] = [];

          const primary = res.cdnURL;

          if (primary) {
            DOMAINS.push(primary);
          }

          const fallbacks = res.fallbackCDNURLs || [];
          console.log(fallbacks);

          fallbacks.forEach((url: string) => {
            if (url && DOMAINS.indexOf(url) === -1) {
              DOMAINS.push(url);
            }
          });

          const getActiveDomain = async (): Promise<string | null> => {

            if (!DOMAINS.length) {
              return null;
            }

            // Change this to an image that exists on every CDN
            const testImagePath = '/CDN/test.png';

            const checks = DOMAINS.map((domain: string) => {

              const imageUrl =
                domain.replace(/\/$/, '') +
                testImagePath +
                '?t=' +
                new Date().getTime();

              return new Promise<string | null>((resolve) => {

                const img = new Image();

                img.onload = () => {
                  console.log('CDN Success:', imageUrl);
                  resolve(domain);
                };

                img.onerror = () => {
                  console.error('CDN Failed:', imageUrl);
                  resolve(null);
                };

                img.src = imageUrl;
              });

            });

            const results = await Promise.all(checks);

            console.log('CDN Results:', results);

            const activeDomain = results.find(result => result !== null);

            return activeDomain || null;
          };

          try {

            const active = await getActiveDomain();

            const activeCdn =
              active ||
              primary ||
              (fallbacks.length ? fallbacks[0] : '');

            console.log('Selected CDN:', activeCdn);

            res.cdnURL = activeCdn;

            localStorage.setItem('cdnURL', activeCdn);

          } catch (cdnError) {

            console.error('CDN Validation Failed:', cdnError);

            res.cdnURL =
              primary ||
              (fallbacks.length ? fallbacks[0] : '');

            localStorage.setItem('cdnURL', res.cdnURL);

          }

          this.route.queryParams.subscribe(async params => {
            console.log(params);

            if (params.tenantId) {
              localStorage.setItem("appCode", params.appCode || '');
              localStorage.setItem("tid", params.tenantId || '');
              localStorage.setItem("_tid", "_" + (params.tenantId || ''));
              localStorage.setItem("userIdFromURL", params.userId || '');
              localStorage.setItem("accessToken", params.access_Token || '');

              if (params.redirectParam) {
                localStorage.setItem("redirectParam", params.redirectParam);
              } else {
                localStorage.setItem("redirectParam", "");
              }
            }

            this.config.getLocalStorageData();

            // Ensure config values are defined before setting url
            this.url = (this.config.cdnURL || '') + '/CDN/' + (this.config._tid || '');

            this.getConuntryData();

            if (params.code) {
              this.loginWithSocial(params);
            }
          });

        } catch (error) {

          console.error('Config Initialization Failed:', error);

        }

      } catch (error) {

        console.error('Config Initialization Failed:', error);

      }

    },
      error => {

        console.error('Failed to load config.json', error);

      }
    );
  }

  ngOnInit() {
    // this.config.getLocalStorageData();
  }

  onlyNumber(evt) {

    evt = (evt) ? evt : window.event;

    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    return true;
  }

  scrollToInput(event: any) {

    // Use querySelector to find the input inside dx-text-box
    const inputEl: HTMLElement | null = event.element.querySelector('input');

    if (inputEl) {

      // Find the nearest .right-content container
      const container = inputEl.closest('.right-content') as HTMLElement;

      if (container) {

        // Scroll smoothly so container is centered
        setTimeout(() => {

          container.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          inputEl.focus();

        }, 50);

      }

    }

  }

  /** To get Country codes */
  getConuntryData() {

    this.loginService.getCountryCode(this.constructor.name).subscribe(result => {

      if (result['message'].code == 0) {

        this.countryCode = result['data']['Country_MsT'];

        this.countryCode.forEach(element => {

          element.country_TEL_Code =
            '+' + element.country_TEL_Code.toString();

          if (
            element.country_Name == 'India' ||
            element.country_Name == 'INDIA'
          ) {
            this.selectedCountryCode = element;
          }

        });

      } else {

        this.toasterService.pop(
          'error',
          result['message'].message
        );

      }

      console.log(this.countryCode);

    });

  }

  loginWithOTPOld(e) {

    console.log(this.selectedCountryCode);

    let result = e.validationGroup.validate();

    if (result.isValid) {

      this.setItems();

      this.loginService.fetchOTP(
        this.phoneNum,
        this.selectedCountryCode.Id,
        this.constructor.name
      ).subscribe(result => {

        if (result["errorCode"] == 0) {

          localStorage.setItem("twoFactor", result['twoFactor']);
          localStorage.setItem("userCode", result['userId']);

          this.router.navigate(['login-with-otp']);

        } else {

          this.toasterService.pop(
            "error",
            result["errorMessage"]
          );

        }

      });

    } else {

      this.toasterService.pop(
        "error",
        "Please provide Mobile Number!"
      );

    }

  }

  loginWithPassword(e) {

    let result = e.validationGroup.validate();

    if (result.isValid) {

      this.setItems();

      this.loginService.verifyMobile(
        this.phoneNum,
        this.selectedCountryCode.Id
      ).subscribe(result => {

        if (result["message"].code == 0) {

          localStorage.setItem(
            "partyEmail",
            result['data'].data[0].party_email
          );

          this.config.getLocalStorageData();

          this.router.navigate(['login-with-password']);

        } else if (result["message"].code == 1005) {

          this.toasterService.pop(
            "error",
            result["message"].message
          );

        } else {

          this.toasterService.pop(
            "error",
            result["message"].message
          );

        }

      });

    } else {

      this.toasterService.pop(
        "error",
        "Please provide Mobile Number!"
      );

    }

  }

  setItems() {

    localStorage.setItem("mobileNumber", this.phoneNum);
    localStorage.setItem("countryCode", this.selectedCountryCode.Id);
    localStorage.setItem(
      "countryTelCode",
      this.selectedCountryCode.country_TEL_Code
    );

  }

  loginWithSocial(params) {

    console.log(params);

    this.loginService.socialLogin(params).subscribe(result => {

      let dobobj = {};
      let genderobj = {};

      if (
        result['data'].fusionAuthUserDetails['data'].birthDate != "" &&
        result['data'].fusionAuthUserDetails['data'].birthDate != null &&
        result['data'].fusionAuthUserDetails['data'].birthDate != 'null'
      ) {

        dobobj = {
          "dob":
            result['data'].fusionAuthUserDetails['data'].birthDate
        };

        this.config.dobobj = dobobj;

      }

      if (
        result['data'].fusionAuthUserDetails['data'].userGender != "" &&
        result['data'].fusionAuthUserDetails['data'].userGender != null &&
        result['data'].fusionAuthUserDetails['data'].userGender != "null"
      ) {

        if (
          result['data'].fusionAuthUserDetails['data'].userGender == "1"
        ) {

          genderobj = {
            "gender": "male"
          };

        } else if (
          result['data'].fusionAuthUserDetails['data'].userGender == "0"
        ) {

          genderobj = {
            "gender": "female"
          };

        } else {

          genderobj = {
            "gender": "other"
          };

        }

        this.config.genderobj = genderobj;

      }

      console.log(genderobj, dobobj);

      if (result["message"].code == 200) {

        console.log(result);

        if (
          result['data'].fusionAuthUserDetails.mobilePhone == null
        ) {

          this.config.userDetails["email"] =
            result['data'].fusionAuthUserDetails.email;

          this.config.userDetails["userId"] =
            result['data'].fusionAuthUserDetails.data.userId;

          this.config.userDetails["mobileNumber"] =
            result['data'].fusionAuthUserDetails.mobilePhone;

          this.config.userDetails["countryCode"] =
            result['data'].fusionAuthUserDetails.countryTelCode;

          this.config.userDetails["userName"] =
            result['data'].fusionAuthUserDetails.fullName;

          this.config.userDetails["partyId"] =
            result['data'].fusionAuthUserDetails.data.partyCode;

          console.log(
            "user data",
            this.config.userDetails
          );

          this.router.navigate([
            'social-signin-register-number'
          ]);

        }

        let mobilePhone =
          result['data'].fusionAuthUserDetails.mobilePhone;

        let countryCode =
          result['data'].fusionAuthUserDetails.countryTelCode;

        if (countryCode == null && mobilePhone != null) {

          this.toasterService.pop(
            "error",
            "Invalid Country code"
          );

          return;

        }

        if (!countryCode.startsWith('+')) {
          countryCode = '+' + countryCode;
        }

        // Remove country code from mobilePhone if it exists
        if (mobilePhone.startsWith(countryCode)) {
          mobilePhone =
            mobilePhone.replace(countryCode, '');
        }

        console.log(
          "Processed Mobile Phone:",
          mobilePhone
        );

        let userDetails = {

          "userId":
            result['data'].fusionAuthUserDetails.data.userId,

          "name":
            result['data'].fusionAuthUserDetails.fullName,

          "email":
            result['data'].fusionAuthUserDetails.email,

          "phone":
            mobilePhone,

          "countryCode":
            result['data'].fusionAuthUserDetails.countryTelCode,

          "redirectParam":
            this.config.redirectParam
              ? this.config.redirectParam
              : "",

          ...genderobj,
          ...dobobj

        };

        console.log(userDetails);

        this.loginService.redirectURL(
          userDetails,
          this.constructor.name
        ).subscribe(results => {

          if (
            results["message"].code == 200 ||
            results["message"].code == 0
          ) {

            let redirectURL =
              results['data'].data.url;

            window.location.href = redirectURL;

          } else if (result["message"].code == 888) {

            console.log("am here");

            this.toasterService.pop(
              'error',
              "Please login after some time!!"
            );

          } else {

            this.toasterService.pop(
              "error",
              result["message"].message
            );

          }

        });

      } else if (result["message"].code == 1005) {

        this.toasterService.pop(
          "error",
          result["message"].message
        );

      } else {

        this.toasterService.pop(
          "error",
          result["message"].message
        );

      }

    });

  }

  loginWithGoogle(e) {

    localStorage.setItem("social", 'Google');

    window.location.href =
      'https://accounts.google.com/o/oauth2/v2/auth?client_id=145109136201-8q4srjnlm4b07s2k7c177937jbu9pmt5.apps.googleusercontent.com&state=' +
      this.config._tid +
      '%26isMobile=4%26user_App_ID=' +
      this.config.appCode +
      '&redirect_uri=' +
      this.config.projectURL +
      '/fynd-login&response_type=code&scope=openid%20email%20profile&access_type=offline&prompt=consent';

  }

  loginWithApple(e) {

    localStorage.setItem("social", 'Apple');

    let params =
      'client_id=bff87de9-fe1a-4404-9a72-f12d07343c44&code_challenge=&code_challenge_method=&metaData.device.name=macOS%20Chrome&metaData.device.type=BROWSER&nonce=&redirect_uri=' +
      this.config.projectURL +
      '/fynd-login&response_mode=&response_type=code&scope=offline_access&state=' +
      this.config._tid +
      '%26isMobile%3D4%26user_App_ID%3D' +
      this.config.appCode +
      '&tenantId=f48037c2-4901-11eb-abd6-020065359cb0&timezone=Asia%2FCalcutta&user_code=&identityProviderId=13d2a5db-7ef9-4d62-b909-0df58612e775';

    let encodedParms = btoa(params);

    console.log(
      'https://appleid.apple.com/auth/authorize?client_id=com.wovvtetch.oken.fusionauth&redirect_uri=https%3A%2F%2Fauthsit.wovvtech.com%2Foauth2%2Fcallback&response_type=code%20id_token&state=' +
      encodedParms +
      '&scope=email%20name&response_mode=form_post&frame_id=539b3717-4897-4a6a-a642-41cfeae6dc41&m=11&v=1.5.4'
    );

    window.location.href =
      'https://appleid.apple.com/auth/authorize?client_id=com.wovvtetch.oken.fusionauth&redirect_uri=https%3A%2F%2Fauthsit.wovvtech.com%2Foauth2%2Fcallback&response_type=code%20id_token&state=' +
      encodedParms +
      '&scope=email%20name&response_mode=form_post&frame_id=539b3717-4897-4a6a-a642-41cfeae6dc41&m=11&v=1.5.4';

  }

  open() {

    this.popupVisible = !this.popupVisible;
    this.filteredCountry = this.countryCode;

  }

  closePopup() {

    this.popupVisible = false;

  }

  loginWithOTP(e) {

    console.log(this.selectedCountryCode);

    let result = e.validationGroup.validate();

    if (result.isValid) {

      this.setItems();

      this.loginService.fetchOTPV2(
        this.phoneNum,
        this.selectedCountryCode.Id,
        this.selectedCountryCode.country_TEL_Code,
        this.constructor.name
      ).subscribe(result => {

        if (result["message"]["code"] == 0) {

          this.toasterService.pop(
            "success",
            result["message"]["message"]
          );

          this.router.navigate(['login-with-otp']);

        } else if (result["code"] == 3096) {

          this.toasterService.pop(
            "error",
            result["message"]["message"]
          );

        } else if (result["code"] == 5006) {

          this.toasterService.pop(
            "error",
            result["message"]["message"]
          );

        } else if (result["code"] == 3097) {

          this.toasterService.pop(
            "error",
            result["message"]["message"]
          );

        } else if (result["code"] == 1005) {

          this.toasterService.pop(
            "error",
            result["message"]["message"]
          );

        } else {

          this.toasterService.pop(
            "error",
            result["message"]["message"]
          );

        }

      });

    } else {

      this.toasterService.pop(
        "error",
        "Please provide 10-digit Mobile number."
      );

    }

  }

  searchWthCountryOrCode(e) {

    console.log(this.searchCountryOrCode);
    console.log(typeof this.searchCountryOrCode);

    if (
      this.searchCountryOrCode &&
      this.searchCountryOrCode.trim() !== ''
    ) {

      let searchValue =
        this.searchCountryOrCode.toLowerCase();

      let searchedCountry =
        this.countryCode.filter((item) => {

          let telCode =
            item.country_TEL_Code != null
              ? item.country_TEL_Code.toString()
              : "";

          return (
            item.country_Name.toLowerCase().includes(searchValue) ||
            telCode.includes(searchValue)
          );

        });

      console.log(searchedCountry);

      this.filteredCountry =
        searchedCountry.length > 0
          ? searchedCountry
          : [];

    } else {

      this.filteredCountry = this.countryCode;

    }

  }

  selectCountry(country) {

    console.log(country);

    this.selectedCountryCode = country;

    this.closePopup();

  }

  disableCopyPaste(e: any) {

    const inputElement: HTMLInputElement | null =
      e.element.querySelector("input");

    if (inputElement) {

      inputElement.addEventListener(
        "paste",
        (ev) => ev.preventDefault()
      );

      inputElement.addEventListener(
        "copy",
        (ev) => ev.preventDefault()
      );

      inputElement.addEventListener(
        "cut",
        (ev) => ev.preventDefault()
      );

    }

  }

}